export const en = {
  // Nav
  "Notifications": "Notifications",
  "More": "More",
  "Logout": "Logout",
  "NoNotifications": "No notifications",
  // Mobile Timesheets
  "WeekTotal": "Week total",
  "entries": "entries",
  "Weekend": "Weekend",
  "AddEntry": "Add entry",
  "SendForApproval": "Send for approval",
  "NoEntriesDay": "No entries for this day",
  "EditEntry": "Edit entry",
  "NewEntry": "New entry",
  "CategoryTask": "Category & task",
  "WhatDidYouDo": "What did you do…",
  "Draft": "Draft",
  "Fulfilled": "Approved",
  "Rejected": "Rejected",
  "SelectTask": "Select a task",
  "EnterTime": "Enter start and end time",
  "EndAfterStart": "End time must be after start",
  "EntryUpdated": "Entry updated",
  "EntryAdded": "Entry added",
  "SaveError": "Save error",
  "ConfirmDelete": "Delete this entry?",
  "DeleteError": "Delete error",
  "SentForApproval": "Sent for approval",
  "WeekReturned": "Week returned to draft",
  "SendWeekTitle": "Send week for approval?",
  "SendWeekWarning": "The whole week will be sent to your supervisor for approval. You won't be able to edit entries until it's reviewed.",
  "hShort": "h",
  "mShort": "m",
  // Mobile Dashboard
  "Hi": "Hi",
  "Worked": "Worked",
  "OnApproval": "On approval",
  "TOILBalance": "TOIL balance",
  "News": "News",
  "NoNews": "No news",
  // Mobile Equipment
  "PATtest": "PAT test",
  "Capitalised": "Capitalised",
  "Warranty": "Warranty",
  "Notes": "Notes",
  "NoEquipment": "No equipment",
  // Mobile Documents
  "OpenDocument": "Open document",
  "Acknowledge": "Acknowledge",
  "NoDocuments": "No documents",
  "Type": "Type",
  "Added": "Added",
  // Mobile sections (Finance/HR/CRM/Training/Booking/Tasks/Community)
  "OnHold": "On hold",
  "Completed": "Completed",
  "Archived": "Archived",
  "NoData": "Nothing found",
  "Approved": "Approved",
  "Paid": "Paid",
  "NoExpenses": "No expenses",
  "AbsentToday": "Absent today",
  "Employees": "Employees",
  "InProgress": "In progress",
  "NotStarted": "Not started",
  "NoCourses": "No courses",
  "Pages": "pages",
  "Questions": "questions",
  "PassThreshold": "Pass threshold",
  "Score": "Score",
  "My": "My",
  "Rooms": "Rooms",
  "Seats": "seats",
  "NoBookings": "No bookings",
  "Done": "Done",
  "High": "High",
  "Medium": "Medium",
  "Low": "Low",
  "NoTasks": "No tasks",
  "Due": "Due",
  "Rental": "Rental",
  "NoEntriesWeek": "No entries this week",
  "Timesheets": "Timesheets",
  "Reports": "Reports",
  "Approve": "Approve",
  "Approvals": "Approvals",
  "Clients": "Clients",
  "Equipment": "Equipment",
  "Booking": "Booking",
  "Expenses": "Expenses",
  "Orders": "Orders",
  "Admin": "Admin",
  "Users": "Users",
  "Toil": "Toil",
  "UsersReports": "Users Reports",
  // Header menu 
  "Setting": "Settings",
  "Profile": "Profile",
  "LogOut": "Log Out",
  "RailSummary": "Smart Summary",
  "RailSchedule": "Schedule",
  "RailManage": "Manage panel",
  "Login": "Login",
  "Search": "Search...",
  "Filter": "Filter",
  "AddFilter": "Add filter",
  "SearchOrFilter": "Search or filter…",
  "Remove": "Remove",
  "Notification": "Notifications",
  // Report table 
  "Date": "Date",
  "StartTime": "Start Time",
  "EndTime": "End Time",
  "Category": "Category",
  "CategoryNew": "Category ★",
  "Task": "Task",
  "Description": "Description",
  "Supervisor": "Supervisor",
  "Hours": "Hours",
  "Edit": "Edit",
  "Download": "Download",
  "AreYouSureDownload": "Are you sure you want to download this report?",
  "ReportList": "Report List",
  // Aprove Table 
  "TotalUserHours": "Total User Hours",
  "TotalCategoryHours": "Total Category Hours",
  "Name": "Name",
  "Total": "Total",
  "ApproveAll": "Approve All",
  "Return": "Return",
  "ApproveAllForWeek": "Approve Week",
  "TotalWeek": "Total Week Hours",
  "RemoveAllForWeek": "Return Week",
  "AreYouSureBack": "Are you sure you want to return all week?",
  "RejectMessage": "Please provide a reason for returning the report",
  "ApproveList": "Approve List",
  // Timesheets 
  "AreYouSureReport": "Are you sure you want to submit a weekly report?",
  "Add": "Add",
  "SendTo": "Send to Approve",
  "SelectUsers": "Select Users",
  "ReturnWeek": "Return Week",
  "ResubmitRejected": "Resubmit rejected",
  "SelectTemplate": "Select Template",
  "PerWee": "Per Week",
  "TOIL": "TOIL",
  "TimesheetsList": "Timesheets List",
  "AddReport": "Add Report",
  "CreateWeekTemplate": "Create Template",
  "ThisWeek": "This Week",
  "ChooseUser": "Choose User",
  "SelectCategory": "Select category...",
  "DescriptionPoins": "Description...",
  "AreYouSureBackWeek": "Are you sure you want to return this week?",
  // Expenses
  "AreYouSureChangeStatus": "Are you sure you want to change",
  "AccountNumber": "Account Number",
  "FinanceAdditionalInfo": "Finance Additional Info:",
  "Visible fields": "Visible fields",
  "Hidden fields": "Hidden fields",
  "StatusExp": "status(es)",
  "to": "to",
  "StatusExpense": "Status",
  "AddExpenses": "Add Expenses",
  "CreateExpenseClaim": "Create a new expense claim",
  "AddIncomeSub": "Record a new income entry",
  "AddCarExpenseSub": "Log a new mileage / car expense",
  "NameCreator": "Name Creator",
  "Staff": "Staff",
  "Amount": "Amount",
  "Phone": "Phone",
  "AddUserInfo": "Add User Info",
  "Project": "Project",
  "ExensesList": "Expenses List",
  "ExpensesList": "Expenses List",
  "Period": "Period",
  "Time": "Time",
  "BrowsePaymant": "Upload Payment",
  "BrowsePayment": "Upload Payment",
  "Payment": "Payment",
  "Car": "Car",
  "Cars": "Cars",
  "Distance": "Distance",
  "Purpose": "Purpose",
  "AddCarExpenses": "Add Car Expenses",
  "AdditionalInfo": "Additional Info",
  "Brand": "Brand",
  "PlateNumber": "Plate Number",
  "Year": "Year",
  "Mileage": "Mileage",
  "Doc": "Doc",
  "FuelType": "Fuel Type",
  "AvgFuelConsumption": "Avg Fuel Consumption",
  "CostPerKm": "Cost Per",
  "Vin": "VIN",
  "InsuranceProvider": "Insurance Provider",
  "InsuranceExpiryDate": "Insurance Expiry Date",
  "InsurancePolicyNumber": "Insurance Policy Number",
  "BrowseInsurance": "Upload Insurance",
  "UsageType": "Usage Type",
  "EditCars": "Edit Cars",
  "CarsInfo": "Cars Info",
  "Active": "Active",
  "AddCars": "Add Car",
  "Destination": "Destination",
  "ExensesCarsList": "Car Expenses List",
  "CarExpensesList": "Car Expenses List",
  "EstimatedCost": "Estimated cost",
  "StaffToggleHint": "Turn off to add payee bank details",
  "NoExpensesAvailable": "No expenses found for the selected period",
  "NoCarExpensesAvailable": "No car expenses found for the selected period",
  "FillRequiredFields": "Fill required fields",
  "ChooseAmount": "Choose Amount",
  "AmountInvalidEnd": "Amount cannot end with a dot or comma",
  "UploadFileRequired": "Please upload a payment document",
  "FileSizeLimit": "File size must be less than 2MB",
  "ChooseCategory": "Choose Category",
  "ChooseCars": "Choose Car",
  "StartingPointRequired": "Starting point is required",
  "DestinationRequired": "Destination is required",
  "PurposeRequired": "Purpose is required",
  "DistanceRequired": "Distance must be greater than 0",
  "RejectionReason": "Rejection Reason",
  "RejectionReasonPlaceholder": "Please provide a reason for rejection...",
  "Confirm": "Confirm",
  "LicenseExpired": "Driver's licence has expired",
  "LicenseExpiringSoon": "Driver's licence expires soon",
  "InsuranceInfo": "Insurance Info",
  "CostCar": "Cost Car",
  "OtherInfo": "Other Info",
  "MOTInfo": "MOT Info",
  "MotExpiryDate": "MOT Expiry Date",
  "BrowseMot": "Upload MOT",
  // Equipment
  "Import": "Import",
  "AreYouSureEquipment": "Are you sure you want download this sample?",
  "AreYouSureEquipmentAll": "Are you sure you want download select equipments?",
  "AddEqp": "Add Equipment",
  "EqpList": "Equipment List",
  "InventoryList": "Inventory List",
  "PatTestList": "PAT-Test List",
  "Number": "Number",
  "Item": "Item",
  "Items": "items",
  "Manufacturer": "Manufacturer",
  "Model": "Model",
  "SerialNumber": "Serial Number",
  "Responsive": "Responsive",
  "PurchaseDate": "Purchase Date",
  "Cost": "Purchase Price",
  "PATTestDate": "PAT Test Date",
  "PATTestDue": "PAT Test Due",
  "PATTestUser": "PAT Test User",
  "Note": "Note",
  "ResponsibleForItem": "Responsible for Item:",
  "WarrantyDue": "Warranty Due",
  "ItemInfo": "Item info",
  "PATInfo": "PAT info",
  "ResponsibleForPAT": "Responsible for PAT",
  "EditEquipment": "Edit Equipment",
  "Eqp": "Equipment",
  "RentalOpportunity": "Rental Opportunity",
  "InventoryID": "Inventory ID",
  "EditEqp": "Edit Equipment",
  "InventoryDate": "Inventory Date",
  "InventoryUser": "Inventory User",
  "InventoryInfo": "Inventory Info",
  "SelectTheNumberOfMonths": "Select the number of months",
  "Selected": "selected",
  "SelectAll": "Select all",
  //Template
  "Template": "Template",
  "Temp": "Template",
  "CreateNew": "Create New",
  "MyTemplates": "My Templates",
  "EditTemp": "Edit Template",
  "To": "to",
  "Empty": "Empty",
  "NoAccess": "No access",
  "StatusUpdateFailed": "Failed to update status. Please try again",
  "NoAccessHint": "Your role does not allow this section. Contact your administrator",
  "AddTempate": "Add Record",
  "CreateWeekTempate": "Create Template From This Week",
  "AddNewTemplate": "Add New Template",
  "Tempate": "Template",
  "мaximum20characters": "Maximum 20 characters",
  "AddTo": "Add to",
  "InsertTemp": "Insert this template into the report?",
  //Docs
  "AddDocs": "Add Docs",
  "AddDocument": "Add Document",
  "EditDocument": "Edit Document",
  "CreateDoc": "Create document",
  "UploadFile": "Upload file",
  "HowAddDoc": "How do you want to add the document?",
  "OpenEditorHint": "Open the editor and write the document",
  "UploadFileHint": "PDF · up to 1 MB",
  "CreateOrUploadHint": "Create or upload a document and choose who must acknowledge it",
  "CreateOrUpload": "Create a document or upload a file",
  "EmptyDocument": "The document is empty",
  "OnlyPdf": "PDF only",
  "StartWriting": "Start writing the document…",
  "NewDocument": "New document",
  "NoDocumentSelected": "No document selected",
  "EditorDraft": "Editor · draft",
  "CurrentFile": "Current file",
  "ReplaceFile": "Replace",
  "OpenToReadSign": "Double-click to read & sign",
  "Text": "Text",
  "select": "select",
  "Title": "Title",
  "Discription": "Description",
  "Info": "Info",
  "ViewDoc": "View",
  "Informed": "Informed",
  "AddFile": "Add File",
  "AllUsers": "All Users",
  "ChooseUsers": "Choose Users",
  "DayLearn": "Review Deadline",
  "Review": "Accept",
  "StatusDoc": "Status",
  "CategoryList": "Category List",
  "DoYouReallyWantToReviewThisDocument": "I have read, understood and agree to the content of the policy",
  "DoYouReallyWantToDeleteThisDocument?": "Do you really want to delete this document?",
  // Docs — Variant 5 grid
  "Filters": "Filters",
  "FileType": "File type",
  "AllStatuses": "All statuses",
  "PolicyStatusNotAssigned": "Not Assigned",
  "PolicyStatusPending": "Pending",
  "PolicyStatusAcknowledged": "Acknowledged",
  "PolicyBtnAcknowledge": "Acknowledge",
  "CardsView": "Cards",
  "SignedOff": "Sign-off",
  "Signed": "Signed",
  "Pending": "Pending",
  "Deadline": "Deadline",
  "ClearAll": "Clear all",
  "AllCategories": "All categories",
  "Days": "days",
  // Booking
  "BookingCalendar": "Booking Calendar",
  "NoBookingsAvailable": "No bookings available",
  "CalendarView": "Calendar",
  "ListView": "List",
  "AddBooking": "Add Booking",
  "EditBooking": "Edit Booking",
  "DeleteBooking": "Delete Booking",
  "BookedFor": "Booked for",
  "PrevMonth": "Previous month",
  "NextMonth": "Next month",
  "AllResources": "All",
  "EquipmentOnly": "Equipment",
  "RoomsOnly": "Rooms",
  "SearchResources": "Search equipment / rooms...",
  "FilterByType": "Type",
  "FilterByUser": "Booked for",
  "ResetFilters": "Reset",
  "BookingOverlapError": "This resource is already booked for the selected period",
  "ResourceType": "Resource type",
  "SelectEquipment": "Select equipment",
  "SelectRoom": "Select room",
  "BookingNotes": "Notes (optional)",
  "ManageRooms": "Rooms",
  "AddRoom": "Add Room",
  "EditRoom": "Edit Room",
  "DeleteRoom": "Delete Room",
  "RoomName": "Room name",
  "RoomLocation": "Location / floor",
  "RoomDescription": "Description",
  "ConfirmDeleteBooking": "Delete this booking?",
  "ConfirmDeleteRoom": "Delete this room?",
  "BookingResource": "Resource",
  // Reports 
  "SortBy": "Sort by",
  "User": "User",
  "StatusReport": "Status",
  "Export": "Export",
  "AddFilters": "Add Filters",
  // Users 
  "Email": "Email",
  "Role": "Role",
  "users": "users",
  "UsersList": "Users List",
  "AddUser": "Add User",
  "fillter": "filter...",
  "EditUser": "Edit User",
  "PersonalInformation": "Personal Information",
  "LastName": "Last Name",
  "SecondName": "Second Name",
  "DateOfBirth": "Date of Birth",
  "Sex": "Sex",
  "WorkInformation": "Work Information",
  "JobTitle": "Job Title",
  "ContractStartDate": "Contract Start Date",
  "Department": "Department",
  "ContractType": "Contract Type",
  "ContractedHoursPerWeek": "Contracted hours per week",
  "MinLeaveEntitlement": "Min. leave entitlement",
  "ContactInformation": "Contact Information",
  "MobilePhone": "Mobile Phone",
  "WorkPhone": "Work Phone",
  "Postcode": "Postcode",
  "City": "City",
  "Address": "Address",
  "OtherSettings": "Other Settings",
  "TimeZone": "Time Zone",
  "NotificationLanguage": "Notification Language",
  "ChangePassword": "Change Password",
  "SavedSuccessfully": "Saved successfully",
  "PhotoUpdated": "Photo updated",
  "PhotoTooLarge": "File must be less than 5 MB",
  "PhotoUploadError": "Upload error",
  "PasswordChanged": "Password changed",
  "PasswordsDoNotMatch": "Passwords do not match",
  "EnterPassword": "Please enter a password",
  "ErrorSaving": "Error saving",
  "RegisterUser": "Register User",
  "RegistrationInformation": "Registration Information",
  "Password": "Password",
  "LastLogin": "Last Login",
  "View": "View",
  "ConfirmPassword": "Confirm Password",
  "FirstName": "First Name",
  "AreYouUser": "Are you sure you want delete this user?",
  "DriverLicense": "Driver License",
  "LicenseExpiryDate": "License Expiry Date",
  "DriverLicenseInfo": "Driver License Info",
  "BrowseLicense": "Upload License",
  "LicenseNumber": "License Number",
  "VehicleClass": "Vehicle Class",
  "IssueDate": "Issue Date",
  "PhotoFront": "Photo (front)",
  "PhotoBack": "Photo (back)",
  "SaveLicense": "Save License",
  "ClickToUpload": "Click to upload",
  // Settings
  "CompanyInfo": "Company Info",
  "CompanyName": "Company Name",
  "EditPanel": "Edit Panel",
  "Settings": 'Settings',
  "AddCategory": "Add Category",
  "AddChildCategoryFor": "Add child category for",
  "SelectSupervisor": "Select supervisor",
  "AddParentCategory": "Add parent category",
  "ChangeNameCategory": "Change name category",
  "ChangeParents": "Change Parents",
  "AreYouSure": "Are you sure you want to delete this",
  "Sourc": "Source",
  "LegalEntityType": "Legal Entity Type",
  "LegalEntity": "Legal Entity",
  "LegalEntityFix": "Legal Entity",
  "Sour": "source",
  "Cat": "Category",
  "Cont": "Contract",
  "Dep": "Department",
  "DepT": "Department",
  "Loc": "Location",
  "Stat": "Status",
  "Equ": "Category Equipment",
  "CatEqu": "Category Equipment",
  "CatEqupm": "Category Equipment",
  "Tasks": "Task",
  "ChangeName": "Change name",
  "AddRole": "Add Role",
  "AddTasks": "Add Tasks",
  "EnterNameOf": "Enter Name of",
  "EditRole": "Edit Role",
  "RoleName": "Role Name",
  "ColorRole": "Color Role",
  "RoleAccess": "Role Access",
  "Delete": "Delete",
  "ShowAll": "Show All",
  "AddEdit": "Add/Edit",
  "AreYouSureRole": "Are you sure you want to delete this Role?",
  "Create": "Create",
  "Location": "Location",
  "Status": "Status",
  "Contract": "Contract",
  "TasksType": "Task",
  "CreateRole": "Create Role",
  "Roles": "Roles",
  "Availability": "Availability",
  "CreateEdit": "Create/Edit",
  "EnterNameOfRole": "Enter Name of Role",
  "ChangeColor": "Change Color",
  "EditTitle": "Edit Title",
  "DeleteRole": "Delete Role",
  // Finance
  "SalaryPerHours": "Salary Per Hours",
  "AddNewSalary": "Add New Salary",
  "DateNewSalary": "Date New Salary",
  "StartDate": "Start Date",
  "CostPerHour": "Cost Per Hour",
  "PerWeek": "Per Week",
  "History": "History",
  "EndDate": "End Date",
  "RemoveAll": "Remove All",
  "Information": "Information",
  "empty": "empty",
  // TOIL 
  "TotalTOIL": "Total TOIL",
  "AddToils": "Add TOIL",
  "AddInformation": "Add information",
  "CreatingDate": "Creating date",
  "TotalHours": "Total hours",
  "OursPerWeek": "Hours per week",
  "Source": "Source",
  "removeTOIL": "TOIL Correction",
  "discriptions": "Descriptions",
  "Refresh": "Refresh",
  // Tasks 
  "AllTasks": "All tasks",
  "SelectTasksPoins": "Select Tasks...",
  // Edit Reports 
  "EditReports": "Edit Reports",
  "EditDate": "Edit Date",
  "EditCategory": "Edit Category",
  "SelectTasks": "Select Tasks",
  "EditDescription": "Edit Description",
  // Delete modal 
  "AreYouReport": "Are you sure you want to delete these Reports?",
  "AreYouReportCat": "Are you sure you want to delete this Category?",
  "AreYouReportCatModal": "Are you sure you want to delete this category",
  // All button 
  "Yes": "Yes",
  "No": "No",
  "Cancel": "Cancel",
  "Change": "Change",
  "Register": "Register",
  "Close": "Close",
  // Other 
  "underDevelopment": "Apologies, this section is currently under development",
  "underDevelopmentSoon": "We expect it to be ready within the next month. Thank you for your patience!",
  "ReturnToHome": "Return To Home",
  "LoginLog": "Login",
  "SignIn": "Sign In",
  "SignUp": "Sign Up",
  "SelectCountry": "Select country",
  "CreateAccount": "Create your account",
  "CreateAccountSub": "Start managing your team with TimeBerlo in minutes.",
  "AuthHeroTitle": "The smarter way to",
  "AuthHeroAccent": "manage your team",
  "AuthHeroSub": "Timesheets, approvals, expenses, HR documents and CRM — all in one place.",
  "TrustSsl": "256-bit SSL",
  "TrustGdpr": "GDPR compliant",
  "AllFieldsRequired": "All fields are required",
  "InvalidEmailFormat": "Invalid email format",
  "RegistrationFailed": "Registration failed. Please try again.",
  "RegistrationSuccess": "Registration was successful",
  "VerifyEmailTitle": "Check your inbox",
  "VerifyEmailSentTo": "We sent a confirmation link to",
  "VerifyEmailDesc": "Click the link in the email to activate your account and start using TimeBerlo.",
  "VerifyEmailSpam": "Didn't receive it? Check your spam folder.",
  "GoToLogin": "Go to Login",
  "EmailAlreadyRegistered": "An account with this email already exists",
  "PasswordRequirements": "Password must be at least 8 characters and include uppercase, lowercase and a special character",
  "OrContinueWith": "or continue with",
  "ComingSoon": "Coming soon",
  "NeedAnAccount": "Need an Account",
  "ForgotPassword": "Forgot password",
  "AlreadyRegistered": "Already registered",
  "PleasePutYourEmail": "Please put your email",
  "Send": "Send",
  "SendReminder": "Send Reminder",
  "Company": "Company",
  "січень": "January",
  "лютий": "February",
  "березень": "March",
  "квітень": "April",
  "травень": "May",
  "червень": "June",
  "липень": "July",
  "серпень": "August",
  "вересень": "September",
  "жовтень": "October",
  "листопад": "November",
  "грудень": "December",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  // CRM & Community
  "CRM": "CRM",
  // Tasks
  "TasksNav": "Tasks",
  "Add task": "Add task",
  "Search tasks": "Search tasks",
  "Assigned": "Assigned",
  "Priority": "Priority",
  "More options": "More options",
  "Add people": "Add people",
  "Add card": "Add card",
  "Drag to reorder": "Drag to reorder",
  "Drop tasks here": "Drop tasks here",
  "Mark as done": "Mark as done",
  "Mark as not done": "Mark as not done",
  "Untitled": "Untitled",
  "Task title…": "Task title…",
  "Description…": "Description…",
  "All": "All",
  "None": "None",
  "Columns": "Columns",
  "Created": "Created",
  "Repeat": "Repeat",
  "Who can see it": "Who can see it",
  "Repeats on": "Repeats on",
  "Everyone": "Everyone",
  "My team": "My team",
  "Assignees only": "Assignees only",
  "Only me": "Only me",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Monthly": "Monthly",
  "On a date…": "On a date…",
  "Created by me": "Created by me",
  "Assigned to me": "Assigned to me",
  "Visible to all": "Visible to all",
  "Board settings": "Board settings",
  "New column name…": "New column name…",
  "DeleteColumnConfirm": "Delete this column? Its cards will move to a neighbouring column.",
  "Delete this card?": "Delete this card?",
  "Available": "Available",
  "Change color": "Change color",
  "Community": "Community",
  "Contacts": "Contacts",
  "Organisations": "Organisations",
  "Projects": "Projects",
  "ContactType": "Contact Type",
  "OrganisationType": "Organisation Type",
  "AddContact": "Add Contact",
  "ContactsList": "Contacts List",
  "AddOrganisation": "Add Organisation",
  "AddProject": "Add Project",
  "MiddleName": "Middle Name",
  "Gender": "Gender",
  "Ethnicity": "Ethnicity",
  "Archive": "Archive",
  "Pseudonymise": "Pseudonymise",
  "PseudonymisationQueue": "Pseudonymisation Queue",
  "ProjectPurpose": "Project Purpose",
  "Commercial": "Commercial",
  "Internal": "Internal",
  "Grant": "Grant",
  "Programmes": "Programmes",
  "Sessions": "Sessions",
  "Participants": "Participants",
  "Monitor": "Monitor",
  "Surveys": "Surveys",
  "Overview": "Overview",
  "FieldSettings": "Field Settings",
  "AddField": "Add Field",
  "Required": "Required",
  "Hidden": "Hidden",
  "FieldType": "Field Type",
  "Section": "Section",
  "AddressLine1": "Address Line 1",
  "AddressLine2": "Address Line 2",
  "Country": "Country",
  "FindAddress": "Find Address",
  "SelectAddress": "Select Address",
  "CharityNumber": "Charity Number",
  "CompanyRegNumber": "Company Reg. Number",
  "VatNumber": "VAT Number",
  "EoriNumber": "EORI Number",
  "EmployeesNumber": "Number of Employees",
  "ContractValue": "Contract Value",
  "ContractRef": "Contract Reference",
  "IsActive": "Active",
  "IsPseudonymised": "Pseudonymised",
  "SortOrder": "Sort Order",
  "Slug": "Slug",
  "Icon": "Icon",
  "ColorType": "Color",
  "FieldConfig": "Field Configuration",
  "Group": "Group",
  "ProjectType": "Project Type",
  "Fields": "Fields",
  "ContactFields": "Contact Fields",
  "SystemFields": "System Fields",
  "CustomFields": "Fields",
  "ProfileFields": "Profile Fields",
  "ProfileWeight": "Weight",
  "AdditionalFields": "Additional Fields",
  "ProfileCompletion": "Profile Completion",
  "HrUserProfile": "User Profile",
  "Field": "Field",
  "Values": "Values",
  "Visible": "Visible",
  // Gender options (by name key)
  "gender_Male": "Male",
  "gender_Female": "Female",
  "gender_NonBinary": "Non-binary",
  "gender_Transgender": "Transgender",
  "gender_Other": "Other",
  "gender_PreferNotToSay": "Prefer not to say",
  // Ethnicity options (by ID — 20 UK census entries)
  "ethnicity_1": "English, Welsh, Scottish, Northern Irish or British",
  "ethnicity_2": "Irish",
  "ethnicity_3": "Gypsy or Irish Traveller",
  "ethnicity_4": "Roma",
  "ethnicity_5": "Any other White background",
  "ethnicity_6": "White and Black Caribbean",
  "ethnicity_7": "White and Black African",
  "ethnicity_8": "White and Asian",
  "ethnicity_9": "Any other Mixed or Multiple ethnic background",
  "ethnicity_10": "Indian",
  "ethnicity_11": "Pakistani",
  "ethnicity_12": "Bangladeshi",
  "ethnicity_13": "Chinese",
  "ethnicity_14": "Any other Asian background",
  "ethnicity_15": "African",
  "ethnicity_16": "Caribbean",
  "ethnicity_17": "Any other Black, Black British, or Caribbean background",
  "ethnicity_18": "Arab",
  "ethnicity_19": "Any other ethnic group",
  "ethnicity_20": "Not stated",
  "EditFields": "Edit fields",
  "SelectField": "Select field",
  "Apply": "Apply",
  "Value": "Value",
  // Training
  "Training": "Training",
  "TrainingMyCourses": "My Training",
  "TrainingAddCourse": "Add Course",
  "TrainingEditCourse": "Edit Course",
  "TrainingAddPage": "Add Page",
  "TrainingEditPage": "Edit Page",
  "TrainingAddQuestion": "Add Question",
  "TrainingEditQuestion": "Edit Question",
  "TrainingMyLearning": "Courses",
  "TrainingLibrary": "Library",
  "TrainingResults": "Results",
  "TrainingManage": "Manage",
  "TrainingCreateCourse": "Create course",
  "TrainingStart": "Start",
  "TrainingRetake": "Retake",
  "TrainingReview": "Review",
  "TrainingStartQuiz": "Take Quiz",
  "TrainingSubmit": "Submit Test",
  "TrainingQuiz": "Quiz",
  "TrainingPages": "pages",
  "TrainingRead": "read",
  "TrainingQuestions": "questions",
  "TrainingNotStarted": "Not started",
  "TrainingPassed": "Passed",
  "TrainingFailed": "Failed",
  "TrainingCorrect": "Correct",
  "TrainingErrors": "Errors",
  "TrainingPassThreshold": "Pass threshold",
  "TrainingForAll": "Assign to all employees",
  "TrainingPageImage": "Page image / attachment",
  "TrainingUploadImage": "Upload image",
  "TrainingImageTooBig": "Image must be less than 5MB",
  "TrainingEnterTitle": "Please enter a title",
  "TrainingEnterQuestion": "Please enter the question text",
  "TrainingMinAnswers": "Please fill in at least 2 answers",
  "TrainingMarkCorrect": "Please mark at least one correct answer",
  "TrainingMarkCorrectHint": "Check the box next to the correct answer(s)",
  "TrainingRetakeMessage": "Score is below {threshold}%. We recommend taking the course again.",
  "TrainingAnswers": "Answer options",
  "TrainingAnswer": "Answer",
  "TrainingQuestionText": "Question",
  "TrainingSaveSuccess": "Saved successfully",
  "TrainingErrorOccurred": "An error occurred",
  "TrainingQuestionType": "Question type",
  "TrainingMarkAllCorrect": "Mark all correct answers",
  "TrainingSelectUsers": "Assign to users",
  "TrainingRetakeInterval": "Retake every N days",
  "TrainingMultipleChoice": "Multiple correct",
  "TrainingTrueFalse": "Yes / No",
  "TrainingSingleChoice": "Single correct",
  "TrainingYesNo": "Yes / No",
  "TrainingSelectAll": "Select all that apply",
  "TrainingAnswered": "Answered",
  "TrainingPagesRead": "Pages read",
  "TrainingQuizScore": "Quiz score",
  "TrainingProgress": "Progress",
  "TrainingContent": "Content",
  "TrainingKnowledgeCheck": "Knowledge check",
  "TrainingModule": "Module",
  "TrainingInProgress": "In progress",
  "TrainingCompleted": "Completed",
  "TrainingCoursesCount": "courses",
  "TrainingTeamProgress": "Team Progress",
  "TrainingCourseSettings": "Course settings",
  "TrainingAssignedTo": "Assigned to",
  "TrainingUsersNotStarted": "Not started",
  "TrainingRemindAll": "Remind incomplete",
  "TrainingRemindSent": "Reminder sent",
  "TrainingResetResults": "Reset completions",
  "TrainingResetConfirm": "Reset all results for this course? Users will need to retake it.",
  "TrainingDeleteCourse": "Delete Course",
  "TrainingDeleteConfirm": "Delete this course? This action cannot be undone.",
  "TrainingNotCompleted": "Not completed",
  "TrainingAllUsers": "All",
  "TrainingReports": "Reports",
  "TrainingCongrats": "Congratulations!",
  "TrainingRemaining": "Remaining",
  "TrainingHtmlView": "HTML",
  "TrainingVisualView": "Visual",
  "TrainingInsertVideoUrl": "Paste video URL (YouTube, Vimeo…)",
  "TrainingPublishDate": "Publish date",
  "TrainingScheduled": "Scheduled",
  "TrainingByDepartment": "By department",
  "TrainingNotifyUsers": "Notify users",
  "TrainingNotifySent": "Notifications sent",
  "TrainingRemindUsers": "Send reminder",
  "TrainingReminderSent": "Reminders sent",
  "HidePanel": "Hide panel",
  "Disk": "Disk",
  "DiskUpload": "Upload",
  "DiskAllFiles": "All files",
  "DiskImages": "Images",
  "DiskDocuments": "Documents",
  "DiskVideos": "Videos",
  "DiskDeleteFile": "Delete file",
  "DiskPickFile": "Choose file",
  "DiskFiles": "Files",
  "DiskStorage": "Storage",
  "DiskTotalUsed": "Total Used",
  "DiskFolders": "Folders",
  "DiskFree": "free",
  "Content": "Content",
  "Save": "Save",
  "Payroll": "Payroll",
  "Income": "Income",
  "Balance": "Balance",
  "Incoming": "Incoming",
  "Outgoing": "Outgoing",
  "Transactions": "Transactions",
  "AddIncome": "Add Income",
  "FillRequired": "Please fill required fields",
  "InviteUser": "Invite user",
  "InviteSent": "Invitation sent",
  "InviteCreatedNoMail": "User created, but the invitation email was not sent — check the company SMTP settings.",
  "InviteHint": "An invitation email with a portal link is sent. The person sets their password, then completes their profile on first login.",
  "SendInvite": "Send invite",
  "InvalidEmail": "Invalid email",
  "DefaultRoleForNew": "Default role for new employees",
  "MakeDefaultForNew": "Make default for new users",
  "SystemRole": "System",
  "SystemRoleHint": "System role — cannot be deleted",
  "HrRoundingDay": "Rounding (days)",
  "HrRoundingHour": "Rounding (hours)",
  "HrRule_up_day": "Up to whole day",
  "HrRule_up_half_day": "Up to half day",
  "HrRule_nearest_half_day": "Nearest half day",
  "HrRule_up_hour": "Up to whole hour",
  "HrRule_up_half_hour": "Up to half hour",
  "HrRule_nearest_half_hour": "Nearest half hour",
  "HrRule_none": "No rounding",
  "HrUseRounding": "Round leave entitlement",
  "HrUnitDay": "day",
  "HrUnitHour": "hour",
  "HrRuleWordUp": "up to",
  "HrRuleWordNearest": "to nearest",
  "HrRuleWordDown": "down to",
  "HrRuleWordUpFrom": "up from",
  "HrStepWholeWord": "whole",
  "HrRoundingDescPrefix": "Entitlement is rounded",
  "HrFromSettings": "rule from HR settings",
  "HrRoundingNoneCfg": "No rounding rule set in HR settings — value stays exact.",
  "HrRoundingOffDesc": "Entitlement is shown exactly, without rounding.",
  "HrRoundedLabel": "Rounded",
  "HrNoRounding": "No rounding",
  "HrRoundingOff": "no rounding",
  "HrRoundingIntro": "How the yearly entitlement is rounded. Threshold = fraction of a step from which it rounds up (0 = always up, 0.5 = standard, 1 = always down).",
  "HrStepWhole": "Whole",
  "HrStepHalf": "0.5",
  "HrStepQuarter": "0.25",
  "HrStepTenth": "0.1",
  "HrRuleAlwaysUp": "Always up (≥0)",
  "HrRuleUp25": "Up from 0.25",
  "HrRuleUp30": "Up from 0.3",
  "HrRuleStandard": "Standard (≥0.5)",
  "HrRuleAlwaysDown": "Always down (≥1)",
  "HrRuleCustom": "Custom…",
  "HrRoundUpFrom": "Round up from",
  "HrErrAfterNext": "The date must be before the next pattern change.",
  "HrContractAfterSegment": "Contract start must be before the next pattern change ({date}). Move or remove that change first.",
  "HrAutoCorr": "auto",
  "HrErrBeforePrev": "The date must be after the previous pattern change.",
  "FillProfileTitle": "Complete your profile",
  "FillProfileHint": "Welcome aboard! Take a minute to complete your details.",
  "RemindNextLogin": "Remind me next login",
  "SaveAndClose": "Save",
  "EmergencyContact": "Emergency contact",
  "SetPassword": "Set password",
  "OrgTree": "Org Tree",
  "OrgChart": "Org Chart",
  "OrgChartEmployees": "Employees",
  "OrgChartDepartments": "Departments",
  "OrgChartManagers": "Managers",
  "OrgChartLevels": "Levels",
  "ExpandAll": "Expand",
  "CollapseAll": "Collapse",
  "AllDepartments": "All departments",
  "NoDepartment": "No department",
  "EditMode": "Edit mode",
  "AddUserToDept": "Add user",
  "AddNewUser": "New user",
  "AddExistingUser": "Existing",
  "AddSubDept": "Sub-dept",
  "OrgManagers": "Managers",
  "OrgEmployees": "Employees",
  "MoveHere": "Move here",
  "AddHere": "Add (duplicate)",
  "DeptHasUsers": "Cannot delete: department has users",
  "OrgSearch": "Search by name or title...",
  "OrgAllDepts": "All departments",
  "OrgSortAZ": "Name A → Z",
  "OrgSortZA": "Name Z → A",
  "OrgStatusActive": "Active",
  "OrgStatusInactive": "Inactive",
  "Deactivate": "Deactivate",
  "Reactivate": "Reactivate",
  "ActiveUsers": "Active Users",
  "InactiveUsers": "Inactive Users",
  "OrgStatusAll": "All",
  "OrgTreeView": "Tree",
  "OrgCardsView": "Cards",
  "OrgListView": "List",
  "Inactive": "Inactive",
  "OrgTabCalendar": "Calendar",
  // History / Logs
  "Logs": "Logs",
  "LogService": "Service",
  "LogSuccess": "Success",
  "LogError": "Error",
  // Corrected keys (replacing misspelled ones)
  "AddTemplate": "Add Template",
  "maximum20characters": "Maximum 20 characters",
  "HoursPerWeek": "Hours per week",
  // Role permissions — module hints
  "RoleHint_finance": "Access to Finance: expenses, income, payroll, car expenses.",
  "RoleHint_timesheets": "Timesheet entries — tracking hours worked per day.",
  "RoleHint_toil": "Time Off In Lieu — extra hours worked vs contracted hours.",
  "RoleHint_equipment": "Equipment register — devices, tools, company assets.",
  "RoleHint_hr": "HR section: employee directory, org chart, departments.",
  "RoleHint_booking": "Room and resource booking for meeting rooms.",
  "RoleHint_docs": "Document storage: policies, contracts, templates.",
  "RoleHint_crm": "CRM — contacts, organisations, and projects.",
  "RoleHint_community": "Community programmes, sessions, participants.",
  "RoleHint_training": "E-learning courses, quizzes, training records.",
  "RoleHint_disk": "File storage — upload, organise, share files.",
  "RoleHint_reports": "Reports: timesheets, absences, payroll, analytics.",
  "RoleHint_orders": "Client orders, service requests, project tracking.",
  "RoleHint_settings": "Company settings: timezone, currency, email, hours.",
  // Role permissions — tab hints
  "RoleHint_finance_expenses": "Own — own expenses. Dept — department. All — all company expenses.",
  "RoleHint_finance_income": "Own — own income. Dept — department. All — all company income.",
  "RoleHint_finance_payroll": "Own — own payslips. All — manage all payroll.",
  "RoleHint_finance_car_expenses": "Own — own claims. Dept — department. All — all mileage records.",
  "RoleHint_timesheets_access": "Own — own timesheet. Dept — department timesheets. All — all company timesheets.",
  "RoleHint_toil_access": "Own — own balance only. Dept — team TOIL. All — all employees.",
  "RoleHint_equipment_access": "Own — items assigned to user. Dept — department. All — all equipment.",
  "RoleHint_hr_access": "Own — own profile. Dept — department members. All — all employees.",
  "RoleHint_booking_access": "Own — own bookings. Dept — department. All — all bookings.",
  "RoleHint_docs_access": "Own — own documents. Dept — department folder. All — all company documents.",
  "RoleHint_community_access": "Own — own sessions. Dept — department programmes. All — all community data.",
  "RoleHint_disk_access": "Own — own files. Dept — shared department files. All — all company files.",
  "RoleHint_reports_access": "Own — own data. Dept — department reports. All — company-wide reports.",
  "RoleHint_orders_access": "Own — assigned orders. Dept — department. All — all company orders.",
  // Role permissions — bool hints
  "RoleHint_finance_approve": "Can approve or reject expense claims from other employees.",
  "RoleHint_finance_admin": "Full access: settings, categories, and all finance records.",
  "RoleHint_timesheets_approve": "Can approve or reject weekly timesheet submissions.",
  "RoleHint_timesheets_admin": "Settings, categories, templates. Can edit or delete any timesheet entry.",
  "RoleHint_toil_manage": "Can manually adjust TOIL balance for any user.",
  "RoleHint_hr_manage": "Can create new employee accounts and edit their details.",
  "RoleHint_hr_admin": "Full admin: delete users, assign roles, manage departments.",
  "RoleHint_booking_admin": "Can create, edit, and delete rooms and resources.",
  "RoleHint_docs_admin": "Can upload documents, create folders, manage read receipts.",
  "RoleHint_training_view": "Can view and complete training courses assigned to them.",
  "RoleHint_training_admin": "Can create, edit, delete courses and questions. View all results.",
  "RoleHint_disk_admin": "Can delete any file including files uploaded by other users.",
  "RoleHint_reports_export": "Can download reports as CSV/Excel. Without this — view only.",
  "RoleHint_orders_manage": "Can create orders, update status, assign to team members.",
  "RoleHint_settings_admin": "Can modify company-wide settings, mail config, and portal setup.",
  "WorkingStatus": "Working status",
  "WorkingStatuses": "Working statuses",
  "AddWorkingStatus": "Add status",
  "WorkingStatusName": "Status name",
  "WorkingStatusColor": "Color",
  "WorkingStatusEmoji": "Icon",
  "WorkingStatusSaved": "Status updated",
  "WorkingStatusClearLabel": "Clear status",
  "WorkingStatusSetup": "Set up your team's working statuses. System statuses cannot be deleted.",
  "SelectExisting": "Select existing",
  "HrLeave": "Leave",
  "HrSickness": "Sickness",
  "HrLateness": "Lateness",
  "HrSettings": "HR Settings",
  "HrScheduleTemplates": "Schedule Templates",
  "HrLeaveTypes": "Leave Types",
  "HrPublicHolidays": "Public Holidays",
  "HrHolidays": "Holidays",
  "HrStatuses": "Statuses",
  "AbsenceLeave": "Absence & Leave",
  "Localization": "Localization",
  "Billing": "Billing",
  "Tools": "Tools",
  "CompanyVehicles": "Company Vehicles",
  "ExpenseFields": "Expense Fields",
  "HrAllowance": "Allowance",
  "HrAllowanceUnit": "Unit",
  "HrPartialDay": "Partial Day",
  "HrRequiresApproval": "Approval",
  "HrTemplateName": "Template name",
  "HrSetAsDefault": "Set as default",
  "HrScheduleTemplatesHint": "Templates define working hours. Assign to employees individually.",
  "HrAbsences": "Absences",
  "HrAbsenceAll": "All",
  "HrAbsenceType": "Absence type",
  "HrAddAbsence": "Add absence",
  "HrEditAbsence": "Edit absence",
  "HrChangeSupervisor": "Override supervisor",
  "HrResetSupervisor": "Reset to default supervisor",
  "HrEmployee": "Employee",
  "HrAddLeave": "Add leave",
  "HrAddSickness": "Add sickness",
  "HrAddLateness": "Add lateness",
  "HrReason": "Reason",
  "HrCertified": "Certified",
  "HrMinutesLate": "Minutes late",
  "From": "From",
  "Today": "Today",
  "Error": "Error",
  "Min": "min",
  "HShort": "h",
  "DShort": "d",
  "HrOverview": "Overview",
  "HrCalendar": "Calendar",
  "HrThisMonth": "This month",
  "HrOut": "out",
  "HrViewMonth": "Month view",
  "HrViewTimeline": "Timeline view",
  "HrToApprove": "To approve",
  "HrMyAbsences": "My absences",
  "HrOutToday": "Out today",
  "HrPendingApproval": "Pending approval",
  "HrUpcomingBirthdays": "Birthdays (2 wks)",
  "HrExpiringDocs": "Expiring documents",
  "HrUpcomingEvents": "Upcoming events",
  "HrBirthday": "Birthday",
  "HrLicenseExpiry": "Licence expiry",
  "HrProbationEnd": "Probation end",
  "HrUsed": "Used",
  "HrRemaining": "Remaining",
  "HrApprove": "Approve",
  "HrReject": "Reject",
  "HrSubmit": "Submit",
  "HrCancel": "Withdraw",
  "HrApproved": "Approved",
  "HrRejected": "Rejected",
  "HrSubmitted": "Request submitted",
  "HrCancelled": "Withdrawn",
  "HrRejectReason": "Reason for rejection",
  "HrDuration": "Duration",
  "HrDurFull": "Full day",
  "HrDurHalfAm": "Half day (morning)",
  "HrDurHalfPm": "Half day (afternoon)",
  "HrDurCustom": "Specify hours",
  "HrDurFullOnly": "Full day (duration choice disabled in settings)",
  "HrSickNote": "Sick note / document",
  "HrRequests": "Absence",
  "Male": "Male",
  "Female": "Female",
  "Others": "Other",
  "HrTabPersonal": "Personal",
  "HrTabEmployment": "Employment",
  "HrTabOvertime": "Overtime",
  "HrTabEmergencies": "Emergencies",
  "HrTabSensitive": "Sensitive",
  "HrTabCustom": "Custom",
  "HrProbationStart": "Probation start",
  "HrNoticePeriod": "Notice period",
  "HrDayOff": "Day off",
  "HrBreak": "break",
  "HrSource": "Source",
  "HrEcName": "Contact name",
  "HrEcRelationship": "Relationship",
  "HrEcPhone": "Phone",
  "HrEcEmail": "Email",
  "HrSensitiveStub": "Stub — fields are disabled. Saving, encryption and access control will be added later.",
  "HrSensNINO": "National Insurance No.",
  "HrSensTaxCode": "Tax code",
  "HrSensPassport": "Passport number",
  "HrSensBankName": "Bank",
  "HrSensAccountHolder": "Account holder",
  "HrSensAccountNumber": "Account number",
  "HrSensSortCode": "Sort code",
  "HrSensIBAN": "IBAN",
  "Rel_spouse": "Spouse",
  "Rel_partner": "Partner",
  "Rel_relative": "Relative",
  "Rel_parent": "Parent",
  "Rel_child": "Child",
  "Rel_sibling": "Sibling",
  "Rel_friend": "Friend",
  "Rel_other": "Other",
  "HrDelete": "Delete",
  "HrConfirmDelete": "Delete this pattern?",
  "HrDuplicate": "Duplicate",
  "HrWorking": "Working",
  "HrUsersUsing": "use this pattern",
  "HrUseToil": "Count overtime (TOIL)",
  "HrUseToilDesc": "If off, TOIL is auto-compensated to zero on timesheet submission (overtime is not accrued).",
  "HrLeaveUnit": "Leave counted in",
  "HrUnitDays": "Days",
  "HrUnitHours": "Hours",
  "HrPhIntro": "Select if employees on this pattern work public holidays and whether they're part of the annual leave entitlement.",
  "HrPhDeducted": "Deducted",
  "HrPhDeductedDesc": "They'll have a day off for public holidays they'd normally work, taken from their yearly holiday entitlement.",
  "HrPhNotDeducted": "Not deducted",
  "HrPhNotDeductedDesc": "They'll have a day off for public holidays they'd normally work, on top of their yearly holiday entitlement.",
  "HrPhWorks": "Works public holidays",
  "HrPhWorksDesc": "Public holidays are treated as a normal day and they won't have the day off.",
  "HrContractTypes": "Contract types",
  "PatternHistory": "Pattern history",
  "ChangePattern": "Change pattern",
  "HrSegmentFrom": "Effective from",
  "HrNoContractDate": "Contract start date is not set — the first segment uses the account creation date. Please fill it in.",
  "HrAddSegment": "Add pattern change",
  "HrOngoing": "ongoing",
  "HrRecalculate": "Recalculate",
  "HrCurrentPattern": "Current pattern",
  "HrBaseByPatterns": "Base by patterns",
  "HrPatternsWord": "patterns",
  "HrWeightedPerWeek": "Weighted h/week",
  "HrWeeksWord": "weeks",
  "HrPatternFromContract": "Applies from contract start · edit patterns below",
  "HrPatternSaved": "Pattern added",
  "HrScheduledChange": "Scheduled",
  "HrDateFromContract": "Date is taken from contract start (not editable)",
  "HrAutoApplyHint": "Applies automatically on {date} at 00:00 ({tz})",
  "HrAddHint": "On save a check runs. If TOIL/leave are affected, you will be asked to confirm.",
  "LocalTime": "local time",
  "HrRecalcNeeded": "Recalculation needed after pattern change",
  "HrRecalcWarnBody": "Pattern saved. The check found discrepancies in TOIL and leave. Review below and Apply to update, or Skip to keep current values.",
  "HrRecalcLogged": "Applying writes an audit-log entry",
  "Skip": "Skip",
  "AllLogs": "All logs",
  "RecalcLogTab": "TOIL & leave recalculation",
  "LogTrigger": "Trigger",
  "ChangedBy": "Changed by",
  "HrRecalcPreview": "Recalculation preview",
  "HrRecalcNoChanges": "No changes — everything is up to date.",
  "HrApplyChanges": "Apply changes",
  "Was": "Was",
  "Now": "Now",
  "NetToilFiltered": "Net TOIL (filtered)",
  "Entries": "Entries",
  "DateOrSource": "date or source...",
  "Clear": "Clear",
  "Week": "Week",
  "Logged": "Logged",
  "Report": "Report",
  "Manual": "Manual",
  "Comment": "Comment",
  "Current": "Current",
  "Initial": "Initial",
  "Loading": "Loading…",
  "HrResetPassword": "Reset password",
  "HrDisableAccount": "Disable account",
  "Activate": "Activate",
  "HrActiveOnly": "Active only",
  "HrNewPassword": "New password",
  "HrSchedule": "Schedule",
  "Start": "Start",
  "End": "End",
  "EffectiveFrom": "Effective from",
  "PreviousPattern": "Previous pattern",
  "ReasonForUpdate": "Reason for update",
  "ActionedDate": "Actioned date",
  "NoPatternHistory": "No pattern changes recorded yet.",
  "HrWorkingPattern": "Working pattern",
  "HrWorkingPatterns": "Working patterns",
  "HrAddPattern": "Add pattern",
  "HrPatternName": "Pattern name",
  "HrWorksHolidays": "Works public holidays",
  "HrPerWeek": "per week",
  "HrExclBreaks": "excl. breaks",
  "Default": "Default",
  "Saved": "Saved",
  "HrGeneral": "General",
  "HrAbsenceSettings": "Absence settings",
  "HrAllowPartialDay": "Allow duration choice (half day, hours)",
  "HrAllowPartialDayHint": "If off, all absences are submitted as a full day with no choice (default).",
  "HrStatus_draft": "Draft",
  "HrStatus_pending": "Pending",
  "HrStatus_approved": "Approved",
  "HrStatus_rejected": "Rejected",
  "HrStatus_cancelled": "Cancelled",
  "HrStatus_recorded": "Recorded",
  "HrStatusApproved": "Approved",
  "HrStatusPending": "Pending",
  "HrStatusRecorded": "Recorded",
  "WD_Mon": "Mon",
  "WD_Tue": "Tue",
  "WD_Wed": "Wed",
  "WD_Thu": "Thu",
  "WD_Fri": "Fri",
  "WD_Sat": "Sat",
  "WD_Sun": "Sun",
  "ReturnDate": "Return date",
  "ContractTypeUseTOIL": "Use TOIL",
  "err_save_generic": "Failed to save changes. Please try again.",
  "err_email_in_use": "This email address is already used by another employee.",
  "err_invalid_enum": "Invalid value in one of the fields (e.g. Gender or Status).",
  "err_invalid_date": "Invalid date in one of the date fields.",
  "err_invalid_number": "Invalid number in one of the numeric fields.",
  "err_fk_not_found": "Related record not found — the department, contract type or role may have been deleted.",
  "ToilAutoCorrection": "Auto correction",
  "Dashboard": "Dashboard",
  "Finance": "Finance",
  "HR": "HR",
  "Docs": "Documents",
  "news_announcements": "Company announcements",
  "news_add": "Add announcement",
  "news_edit": "Edit",
  "news_delete": "Delete",
  "news_pin": "Pin",
  "news_unpin": "Unpin",
  "news_pinned": "Pinned",
  "news_publish": "Publish",
  "news_save": "Save changes",
  "news_all": "All news",
  "news_title_label": "Title",
  "news_body_label": "Message",
  "news_title_placeholder": "e.g. Office closure — Bank Holiday 23 June",
  "news_body_placeholder": "Write your announcement here…",
  "news_emoji_label": "Icon (emoji)",
  "news_color_label": "Icon background",
  "news_pin_label": "Pin this announcement",
  "news_pin_hint": "Pinned posts always appear first and are highlighted with a badge",
  "news_preview_label": "Preview",
  "RoleHint_dashboard_settings": "Can access dashboard settings and manage all announcements (pin, delete any).",
  "RoleHint_dashboard_widget_feed_enabled": "The news feed widget is available for adding to the dashboard.",
  "RoleHint_dashboard_edit_own": "Can rearrange, add and remove blocks on their own dashboard.",

  "AddedBy": "Added by",
  "DirectLink": "Direct link",

  // ImageUpload universal component
  "ImgUpTitle": "Insert image",
  "ImgUpTitleSub": "Upload, crop and optimise",
  "ImgUpFile": "File",
  "ImgUpCamera": "Camera",
  "ImgUpDrop": "Drop image here",
  "ImgUpDropSub": "or click to select · up to 20 MB",
  "ImgUpChooseFile": "Choose file",
  "ImgUpEditorTitle": "Image editor",
  "ImgUpMode": "Mode",
  "ImgUpModeOptimize": "Optimise",
  "ImgUpModeCrop": "Crop",
  "ImgUpModeOriginal": "Original",
  "ImgUpModeOptimizeHint": "Optimise mode · no crop",
  "ImgUpModeOriginalHint": "File uploads without changes",
  "ImgUpRatio": "Ratio",
  "ImgUpFree": "Free",
  "ImgUpZoom": "Zoom",
  "ImgUpRotation": "Rotation",
  "ImgUpQuality": "Quality",
  "ImgUpMaxWidth": "Max width",
  "ImgUpOriginalSize": "original",
  "ImgUpAfterSize": "Result",
  "ImgUpFilename": "File name",
  "ImgUpInsert": "Insert ↵",
  "ImgUpBack": "← Back",
  "ImgUpSnap": "Take photo",
  "ImgUpRetake": "↩ Retake",
  "ImgUpCamError": "Camera unavailable. Allow access in browser settings.",
  "ImgUpOriginalWarn": "Are you sure?",
  "ImgUpOriginalWarnText": "Original file is {size}. After optimisation it would be ~{opt} — {pct}% smaller.",
  "ImgUpCompress": "Better to compress",
  "ImgUpUploadOriginal": "Upload original anyway",
  "ImgUpProcessing": "Processing…",

  // Settings — Users Management
  "SettingsUsersTitle": "Company Users",
  "ResetPassword": "Reset Password",
  "NewPassword": "New Password",
  "PasswordMinLength": "Minimum 6 characters",
  "EditRoles": "Edit Roles",
  "RolesUpdated": "Roles updated",
  "HrLeaveBalance": "Leave",
  "AnnualLeave": "Annual Leave",
  "HrEntitlement": "Entitlement",
  "HrEntitlementBase": "Base entitlement",
  "HrProRata": "Part year",
  "HrAdjustment": "Adjustment",
  "HrAdjustments": "Adjustments",
  "HrPending": "Booked",
  "HrShowApproved": "Archive",
  "HrUsage": "Usage",
  "HrAmount": "Amount",
  "HrUnit": "Unit",
  "HrLeaveYear": "Leave year",
  "HrMainLeaveType": "Main leave type",
  "HrAdjKind": "Adjustment type",
  "HrAdjKind_carryover": "Carryover",
  "HrAdjKind_bonus": "Bonus",
  "HrAdjKind_buy": "Buy",
  "HrAdjKind_sell": "Sell",
  "HrAdjKind_manual": "Manual",
  "Employee": "Employee",
  "Deleted": "Deleted",
  "Pattern": "Pattern",
  "Prev": "Previous",
  "Next": "Next",
  "HrLeaveRules": "Leave calculation rules",
  "HrLeaveYearStart": "Leave year start",
  "HrLeaveUnitBasis": "Counting unit",
  "HrUnitBasis_working_days": "Working days",
  "HrUnitBasis_calendar_days": "Calendar days",
  "HrUnitBasis_hours": "Hours",
  "HrEntitlementFormula": "Entitlement formula",
  "HrFormula_weeks": "Weeks × hours/week",
  "HrFormula_days": "Fixed days",
  "HrFormula_hours": "Hours",
  "HrEntitlementWeeks": "Statutory weeks / base days",
  "HrAccrualMode": "Accrual mode",
  "HrAccrual_upfront": "Upfront (pro-rata)",
  "HrAccrual_monthly": "Monthly (accrual)",
  "HrAccrualRate": "Accrual rate (days/month)",
  "HrRounding": "Rounding",
  "HrRound_none": "None",
  "HrRound_half_up": "Up to 0.5 day",
  "HrRound_full_up": "Up to 1 day",
  "HrRound_nearest_half": "Nearest 0.5",
  "HrRound_tenth": "To 0.1",
  "HrCarryoverMax": "Carryover limit (days)",
  "HrHolidayPatternInfo": "Public-holiday handling is set per working pattern.",
  "Month": "Month",
  "Day": "Day",
  "HrSelectEmployee": "Select an employee to see their leave balance",
  "HrAbsenceHistory": "Absence history",
  "Auto": "Auto",
  "HrUnitModeHint": "Auto uses the unit from the working pattern",
  "HrServiceLength": "Work experience",
  "HrHiredSince": "since",
  "HrNonWorkingDay": "This is a non-working day and cannot be booked",
  "HrTimeStep": "Time step",
  "HrTimeStepHint": "Applies to leave hours and timesheets",
  "HrYearBasis": "Pro-rata year basis",
  "HrYearBasis_calendar": "Calendar days (365 / 366 in leap year)",
  "HrYearBasis_working": "Working days (Mon–Fri, ~261 per year)",
  "HrYearBasisHint": "Day count used as denominator for pro-rata when staff start mid-year. 'Working days' matches payroll systems using 261 as the annual base.",
  "HrLeaveCalc": "Leave calculation",
  "HrServiceBands": "Extra days for length of service",
  "HrServiceBandsHint": "Auto-added to the main leave type based on hire date",
  "HrServiceYears": "Years of service ≥",
  "HrExtraDays": "Extra days",
  "HrAddBand": "Add band",
  "HrDirection": "Direction",
  "HrAdd": "Add",
  "HrDeduct": "Deduct",
  "HrHours": "Hours",
  "HrMinutes": "Minutes",
  "HrHowCalculated": "How it is calculated",
  "HrCalcBase": "Base (per year)",
  "HrCalcService": "Long Service Bonus",
  "HrYearsShort": "y",
  "HrMonthsShort": "m",
  "HrEvent": "Event",
  "HrCarryover": "Rollover",
  "HrCarryoverAll": "Rollover all",
  "HrCarryoverRemainder": "Carry over to",
  "HrHoursToCarry": "Hours to carry",
  "HrToCarry": "To carry",
  "HrCarriedOver": "Carried over",
  "HrSkipped": "skipped",
  "HrNothingToCarry": "Nothing to carry over",
  "HrAlreadyCarried": "already carried",
  "HrDeleted": "Deleted",
  "Ready": "Ready",
  "Driver": "Driver",
  "Drivers": "Drivers",
  "Insurance": "Insurance",
  "Provider": "Provider",
  "PolicyNumber": "Policy number",
  "ExpiryDate": "Expiry date",
  "CarExpenses": "Car Expenses",
  "AddVehicle": "Add vehicle",
  "EditVehicle": "Edit vehicle",
  "Expired": "Expired",
  "NotSet": "Not set",
  "AnyDriver": "Any driver",
  "AnyEmployee": "Any employee can drive",
  "DefaultCar": "Default car",
  "Petrol": "Petrol",
  "Diesel": "Diesel",
  "Electric": "Electric",
  "Hybrid": "Hybrid",
  "Personal": "Personal",
  "Business": "Business",
  "Mixed": "Mixed",
  "You": "you",
  "SelectCars": "Select car",
  "Document": "Document",
  "AddPolicy": "Add policy",
  "EditPolicy": "Edit policy",
  "CoveredVehicles": "Covered vehicles",
  "SelectVehicles": "Select vehicles",
  "NoVehicles": "No vehicles",
  "NoPolicies": "No policies",
  "Contracts": "Contracts",
  "NewContract": "New contract",
  "UploadContract": "Upload",
  "ContractTitle": "Contract title",
  "ContractTitlePlaceholder": "e.g. Employment Agreement",
  "ContractFile": "File (PDF, DOCX)",
  "ContractSigned": "Signed",
  "ContractPending": "Awaiting signature",
  "ContractDraft": "Draft",
  "NoContracts": "No contracts yet",
  "SearchContracts": "Search contracts…",
  "DropContractHere": "Drop PDF or DOCX here, or click to browse",
  "DropContractSub": "Max 20 MB · PDF, DOCX supported",
  "ElectronicSignature": "Electronic signature",
  "DrawSignatureHint": "Draw your signature to confirm this document",
  "SignHere": "Draw your signature here",
  "SignHereSub": "Use mouse or touchscreen",
  "SignatureCaptured": "Signature captured",
  "SignAndSubmit": "Sign and submit",
  "SignAs": "Sign as",
  "SignLegalNotice": "By clicking \"Sign and submit\", you confirm that you have read this document and agree to sign it electronically. This signature is legally binding.",
  "BackToContracts": "Back to contracts",
  "ContractDraftNotice": "This contract is in draft. Upload a file and send it for signing.",
  "NoFileAttached": "No file attached",
  "DeleteContractConfirm": "Delete this contract?",
  "StepReview": "Review",
  "StepSign": "Sign",
  "StepSubmit": "Submit",
  "NoDrivers": "No drivers",
  "Idle": "Idle",
  "DaysShort": "d",
  "CurrentDocument": "Current document",
  "BrowseDocument": "Upload document",
  "TrainingPublished": "Published",
  "TrainingUnpublished": "Unpublished",
  "TrainingDraft": "Draft",
  "TrainingPublishToggleHint": "Toggle published / draft",
  "HrRebalanceTitle": "Rebalance TOIL by week",
  "HrWeeksToFix": "Weeks to fix",
  "HrDeleteManual": "Delete manual",
  "HrRebalanceAll": "Rebalance all",
  "HrToilByWeek": "TOIL by week",
  "HrPatternOfWeek": "Pattern of week",
  "HrWeekBalance": "Week balance",
  "HrChanges": "Changes",
  "HrUsesToil": "With TOIL",
  "HrNoToil": "No TOIL",
  "HrWeekPatternIs": "Pattern in effect this week",
  "HrWeekUsesToil": "Pattern uses TOIL → overtime goes to the TOIL balance. Report is recalculated, any auto-correction is removed, manual corrections are kept.",
  "HrWeekNoToil": "Pattern does NOT use TOIL → overtime is zeroed by an auto-correction, and all manual corrections for this week are removed (they duplicate the offset).",
  "HrReportRecalc": "Report — recalculated by pattern",
  "HrToilWasNow": "TOIL was → now",
  "HrAutoCorrection": "Auto-correction (zeroing overtime)",
  "HrAction": "Action",
  "HrManualOfWeek": "Manual corrections of the week",
  "HrSum": "Sum",
  "HrWhatHappens": "Result",
  "HrKeep": "keep",
  "HrRebalanceWeek": "Rebalance week",
  "HrCreate": "create",
  "HrUpdate": "update",
  "HrRebalanceNote": "Each apply writes an audit-log entry. Nothing changes without confirmation.",
  "HrRecalcReportLine": "Recalculate report by pattern",
  "HrManualCorr": "Manual correction",
  "HrWeekResult": "Week result",
  "HrRebalanceAllBody": "All weeks below will be rebalanced at once, and annual leave will be recalculated.",
  "HrWeeksToRebalance": "weeks to rebalance",
  "HrManualToDelete": "manual corrections to delete",
  "HrLeaveToRecalc": "leave periods to recalculate",
  "HrRebalance": "Rebalance",
  "DriverLicence": "Driving licence",
  "LicenceNotAdded": "Not added",
  "Until": "until",
  "LicenceNumber": "Licence number",
  "LicenceCategories": "Categories (vehicle types)",
  "SelectCategories": "Select categories",
  "LicencePhotos": "Licence photos",
  "TwoSides": "front & back",
  "FrontSide": "Front side",
  "BackSide": "Back side",
  "UploadPhoto": "Upload photo",
  "LicenceHint": "All fields and both photos are required. When creating a Car Expense the system checks that the licence is added and valid.",
  "LicencePhotosRequired": "Both licence photos are required",
  "NoLicence": "No licence",
  "LicenceOk": "Licence",
  "LicenceExpiredShort": "Licence expired",
  "MyLicence": "My driving licence",
  "FromWhom": "From",
  "ClaimDateLimits": "Claim Date Limits",
  "ClaimDaysHint": "Set the maximum number of days in the past an employee can select when submitting a claim. Leave empty to allow any date.",
  "ExpensesClaimDays": "Expenses — max days back",
  "ExpensesClaimDaysHint": "e.g. 30 — receipts must be submitted within 30 days of purchase",
  "CarExpensesClaimDays": "Car Expenses — max days back",
  "CarExpensesClaimDaysHint": "e.g. 30 — mileage claims must be submitted within 30 days of the journey",
  "SelectEmployee": "Select employee",
  "NoEmployeesWithoutLicense": "All employees already have a license",
  "HrMyRequest": "My request",
  "HrForEmployee": "For {{name}} · added by HR",
  "Optional": "optional",
  "HrNotePlaceholder": "Add a note for your supervisor",
  "HrResetFullDay": "Reset to full day",
  "HrFitNote": "Fit note",
  "HrAttachment": "Attachment",
  "HrDropFile": "Drop file here or",
  "HrBrowse": "browse",
  "HrFileTypes": "PDF, JPG or PNG · up to 10 MB",
  "HrFitNoteRequired": "Fit note required for absences over 7 days",
  "HrDaysShort": "days",
  "HrEndBeforeStart": "End is before start",
  "HrOverBalance": "Not enough balance for this request",
  "HrWorkingDaysN_one": "{{count}} working day",
  "HrWorkingDaysN_other": "{{count}} working days",
  "HrSendRequest": "Send request",
  "HrLeftAfterRequest": "{{left}} of {{total}} {{unit}} left"
}
